import * as React from 'react';
import { path, pathOr } from 'ramda';

import { IBaseQuestionProps } from '../types/internal';
import { QuestionLayoutContainer } from '../../QuestionLayoutContainer';
import { useFormTracking } from '../../../utils/useFormTracking';
import { FormInputsLayout } from '../../../components/FormInputsLayout';

export const InputRenderer: React.FC<IBaseQuestionProps> = props => {
  const { trackSubmit, trackChange } = useFormTracking();
  const {
    question: { answerField, placeholder, unit, required, title },
    setAnswer,
    answersState,
    setNextStep,
  } = props;

  const handleSubmit = React.useCallback(() => {
    setNextStep(answersState);
    trackSubmit({
      isRequired: required,
      value: pathOr('', [answerField, 'value'], answersState),
      field: answerField,
    });
  }, [trackSubmit, answersState, setNextStep, answerField, required]);

  const handleChange = React.useCallback<NonNullable<React.ComponentProps<'input'>['onChange']>>(
    e => {
      setAnswer({ answerField, value: e.target.value });
      trackChange();
    },
    [setAnswer, answerField, trackChange],
  );

  const isNextBtnDisabled = required && !Boolean(path([answerField, 'value'], answersState));

  return (
    <QuestionLayoutContainer title={title} onSubmit={handleSubmit} disableSubmit={isNextBtnDisabled}>
      <FormInputsLayout
        InputProps={{
          type: 'text',
          placeholder: placeholder || '',
          onChange: handleChange,
          value: pathOr('', [answerField, 'value'], answersState),
          rightEnhancer: unit,
        }}
        fullwidth
      />
    </QuestionLayoutContainer>
  );
};

InputRenderer.displayName = 'InputRenderer';
